import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Specular$dDom$dBuilder$dClass from "../Specular.Dom.Builder.Class/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
const identity = x => x;
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const triggerCallback = () => identity;
const newCallback = () => dictMonadEffect => dictMonadEffect.Monad0().Bind1().Apply0().Functor0().map(v => ({event: v.event, callback: v.fire}))(Specular$dFRP$dBase.newEvent(dictMonadEffect));
const mkCallback = () => identity;
const mbCallback = () => traverse_;
const dynCallback = () => dynCb => x => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(dynCb);
  return () => {
    const cb = $0();
    return cb(x)();
  };
};
const contramapCallbackEffect = () => f => cb => a => {
  const $0 = f(a);
  return () => {
    const $1 = $0();
    return cb($1)();
  };
};
const contramapCallbackDyn_ = () => fD => cb => v => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(fD);
  return () => {
    const f = $0();
    return cb(f)();
  };
};
const contramapCallbackDynMaybe = () => fD => cb => x => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(fD);
  return () => {
    const f = $0();
    return traverse_(cb)(f(x))();
  };
};
const contramapCallbackDyn = () => fD => cb => x => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(fD);
  return () => {
    const f = $0();
    return cb(f(x))();
  };
};
const attachEvent = () => dictMonadFRP => {
  const subscribeEvent_ = Specular$dFRP$dBase.subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1());
  return event => cb => subscribeEvent_(cb)(event);
};
const attachDyn = () => dictMonadFRP => {
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  return dyn => cb => subscribeDyn_(cb)(dyn);
};
const attachDomEvent = () => dictMonadFRP => {
  const bind1 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind;
  const domEventWithSample = Specular$dDom$dBuilder$dClass.domEventWithSample(dictMonadFRP);
  const attachEvent2 = attachEvent()(dictMonadFRP);
  return eventType => node => callback => bind1(domEventWithSample(Effect.pureE)(eventType)(node))(event => attachEvent2(event)(callback));
};
export {
  attachDomEvent,
  attachDyn,
  attachEvent,
  contramapCallbackDyn,
  contramapCallbackDynMaybe,
  contramapCallbackDyn_,
  contramapCallbackEffect,
  dynCallback,
  identity,
  mbCallback,
  mkCallback,
  newCallback,
  traverse_,
  triggerCallback
};
